// src/api/useSignUp.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import api from "../utils/api";

const fetchCreateAgenda = ({ studyId, data }) => {
  return api.post("/agenda", { studyId, data });
};

/**
 * 회원가입 요청을 위한 useMutation 훅을 사용하는 커스텀 훅
 */
export const useCreateAgendaQuery = () => {
  return useMutation({
    mutationFn: fetchCreateAgenda,
  });
};
